import { QuestionJurisdictionDropDownField } from 'components/Questionnaires/fields';
import { requiredValidator } from 'components/Questionnaires/validators';

export function incorporationCountryBlock() {
  return {
    id: 'incorporationCountry',
    title: 'questionnaire.incorporationCountry',
    component: undefined,
    info: {
      instructions: 'questionnaire.incorporationCountry.info'
    },
    visible: true,
    questions: [
      {
        id: 'country',
        label: 'questionnaire.incorporationCountry.label',
        component: QuestionJurisdictionDropDownField,
        visible: true,
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.incorporationCountry.errorMessage' }
          ]
        }
      },
    ],
  };
}

export default incorporationCountryBlock;
